"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHeaderProps = exports.HeaderPropsContext = void 0;
var react_1 = require("react");
exports.HeaderPropsContext = (0, react_1.createContext)(undefined);
function useHeaderProps() {
    return (0, react_1.useContext)(exports.HeaderPropsContext);
}
exports.useHeaderProps = useHeaderProps;
